import React from 'react';
import { connect } from 'react-redux';
import { MuiThemeProvider, Typography, withStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import agreementReportStyle from './AgreementReportStyle';
import { AGREEMENT_DROPDOWN_THEME } from './AgreementMuiTheme';
import { isNotBlank } from '../Common/Utils/StringUtils';

const AgreementList = (props) => {
    const { classes, loadAccepted } = props;
    const frameData = () => {
        let filteredResult = [];
        props.signedAgreements.map((rowData) => {
            let rowDataCopy = { ...rowData };
            if (loadAccepted ? rowDataCopy.is_agreed : !rowDataCopy.is_agreed) {
                rowDataCopy.ip_address = isNotBlank(rowData.ip_address) ? rowData.ip_address : '-';
                rowDataCopy.version = isNotBlank(rowData.version) ? rowData.version : '-';
                return filteredResult.push(rowDataCopy);
            }
        });
        return filteredResult;
    };

    const ellipsis = (data, length) => {
        if (data !== null) {
            return data.length < length ? data : data.substring(0, length) + ' ...';
        }
    };

    const data = frameData();

    const columns = [
        {
            name: 'user_name',
            label: 'User Name',
            options: {
                customBodyRender: (value) => {
                    return <Typography id={'userName_' + value}>{ellipsis(value, 35)}</Typography>;
                },
                filter: true,
                sort: true
            }
        },
        {
            name: 'email',
            label: 'Email',
            options: {
                customBodyRender: (value) => {
                    return <Typography id={'email_' + value}>{ellipsis(value, 60)}</Typography>;
                },
                filter: true,
                sort: true
            }
        },
        {
            name: 'ip_address',
            label: 'IP Address',
            options: {
                customBodyRender: (value) => {
                    return <Typography id={'ipAddress_' + value}>{value}</Typography>;
                },
                filter: true,
                sort: false,
                display: loadAccepted
            }
        },
        {
            name: 'version',
            label: 'Version',
            options: {
                customBodyRender: (value) => {
                    return <Typography id={'version_' + value}>{value}</Typography>;
                },
                filter: true,
                sort: false,
                display: loadAccepted
            }
        },
        {
            name: 'agreed_on',
            label: 'Signed On',
            options: {
                customBodyRender: (value) => {
                    return <Typography id={'agreedOn_' + value}>{value}</Typography>;
                },
                filter: true,
                sort: false,
                display: loadAccepted
            }
        }
    ];

    const options = {
        textLabels: {
            body: {
                noMatch: 'No record found'
            }
        },
        selectableRows: 'none',
        pagination: true,
        rowsPerPageOptions: [10, 15, 20],
        sort: true,
        filter: false,
        search: false,
        download: false,
        print: false,
        viewColumns: false,
        rowHover: false,
        tableBodyHeight: '40rem'
    };

    return (
        <div className={classes.noHeight}>
            <MuiThemeProvider theme={AGREEMENT_DROPDOWN_THEME}>
                <MUIDataTable data={data} columns={columns} options={options} />
            </MuiThemeProvider>
        </div>
    );
};

const mapStateToProps = (state) => ({
    signedAgreements: state.termsAndConditions.signedAgreements
});

export default connect(mapStateToProps, {})(withStyles(agreementReportStyle)(AgreementList));
